import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InteractionCompleteComponent } from './interaction-complete.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: ':type/:id',
    component: InteractionCompleteComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InteractionCompleteRoutingModule { }
